import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const BASE = 'RestaFlex';
const FALLBACK = `${BASE} — Restoran Yönetim Sistemi`;

// Route prefix → i18n key. Longer/more specific prefixes first so that
// `/chain/staff` matches `caNavStaff` instead of the generic `/chain` entry.
const ROUTE_TITLE = [
  // Chain admin subroutes
  ['/chain/staff',               'caNavStaff'],
  ['/chain/branches',            'caNavBranches'],
  ['/chain/reports',             'caNavReports'],
  ['/chain/analytics',           'caNavAnalytics'],
  ['/chain/menu',                'caNavChainMenu'],
  ['/chain',                     'chainAdminTitle'],
  // SuperAdmin subroutes
  ['/superadmin/restaurants',    'saNavRestaurants'],
  ['/superadmin/plans',          'saNavPlans'],
  ['/superadmin/subscriptions',  'saNavSubscriptions'],
  ['/superadmin',                'superAdminTitle'],
  // Restaurant routes
  ['/tables',                    'nav_tables'],
  ['/orders',                    'nav_orders'],
  ['/kitchen',                   'nav_kitchen'],
  ['/payments',                  'nav_payments'],
  ['/pos',                       'nav_pos'],
  ['/menu-management',           'nav_menu'],
  ['/stock',                     'nav_stock'],
  ['/recipes',                   'nav_recipes'],
  ['/customers',                 'nav_customers'],
  ['/reservations',              'nav_reservations'],
  ['/shifts',                    'nav_shifts'],
  ['/delivery-orders',           'nav_delivery'],
  ['/promo-codes',               'nav_promo'],
  ['/gift-vouchers',             'nav_gifts'],
  ['/users',                     'nav_users'],
  ['/waiter-stats',              'nav_waiterStats'],
  ['/reports',                   'nav_reports'],
  ['/platform-management',       'nav_platforms'],
  ['/audit-logs',                'nav_audit_logs'],
  ['/trash',                     'nav_trash'],
  ['/security',                  'nav_security'],
  ['/tax-groups',                'nav_tax_groups'],
  ['/feature-flags',             'nav_feature_flags'],
  ['/settings',                  'nav_settings'],
  ['/white-label',               'nav_whitelabel'],
  ['/my-subscription',           'nav_subscription'],
  ['/notifications',             'nav_notifications'],
  // Dashboard (root) — must be last since every path starts with '/'
  ['/',                          'nav_dashboard'],
];

export default function DocumentTitle() {
  const { pathname } = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    const match = ROUTE_TITLE.find(([prefix]) =>
      prefix === '/' ? pathname === '/' : (pathname === prefix || pathname.startsWith(prefix + '/'))
    );
    const label = match ? t(match[1]) : '';
    document.title = label ? `${label} · ${BASE}` : FALLBACK;
  }, [pathname, t]);

  return null;
}
